import React from 'react';
import bi from 'shared/bi/bi';
import { getCompId } from 'shared/utils/comp-id';
import WixSDK from 'shared/utils/wix-sdk';

export const BI_EVENT = 'BI_EVENT';
const currentCompId = getCompId();

export default class BiHandler extends React.Component {
  componentDidMount() {
    WixSDK.PubSub.subscribe(BI_EVENT, this.sendBiEvent);
  }

  componentWillUnmount() {
    WixSDK.PubSub.unsubscribe(BI_EVENT, this.sendBiEvent);
  }

  sendBiEvent = ({ data }) => {
    const { eventName, params, targetCompId } = data;
    if (targetCompId === currentCompId) {
      bi.log(eventName, params);
    }
  };

  render() {
    return null;
  }
}
